import "./skeletion.css";

const WarehouseSkeleton = () => {
  return (
    <div className='stock-skeleton'>
      {/* Header Section */}
      <div className='stock-skeleton__header'>
        <div className='stock-skeleton__store-icon'></div>
        <div className='stock-skeleton__store-info'>
          <div className='stock-skeleton__store-name'></div>
          <div className='stock-skeleton__store-address'></div>
        </div>
        <div className='stock-skeleton__delete-btn'></div>
      </div>

      {/* Back Button */}
      <div className='stock-skeleton__back-btn'></div>

      {/* Tabs Section */}
      <div className='stock-skeleton__tabs'>
        <div className='stock-skeleton__tab stock-skeleton__tab--active'></div>
        <div className='stock-skeleton__tab'></div>
      </div>

      {/* Search Section */}
      <div className='stock-skeleton__search-container'>
        <div className='stock-skeleton__search-input'></div>
        <div className='stock-skeleton__search-btn'></div>
      </div>

      {/* Table Header */}
      <div className='stock-skeleton__table-header'>
        <div className='stock-skeleton__header-cell stock-skeleton__header-cell--picture'></div>
        <div className='stock-skeleton__header-cell stock-skeleton__header-cell--created'></div>
        <div className='stock-skeleton__header-cell stock-skeleton__header-cell--name'></div>
        <div className='stock-skeleton__header-cell stock-skeleton__header-cell--brand'></div>
        <div className='stock-skeleton__header-cell stock-skeleton__header-cell--cost'></div>
        <div className='stock-skeleton__header-cell stock-skeleton__header-cell--available'></div>
        <div className='stock-skeleton__header-cell stock-skeleton__header-cell--restock'></div>
        <div className='stock-skeleton__header-cell stock-skeleton__header-cell--move'></div>
      </div>

      {/* Table Rows */}
      {[1, 2, 3, 4].map((index) => (
        <div key={index} className='stock-skeleton__table-row'>
          <div className='stock-skeleton__row-cell stock-skeleton__row-cell--picture'>
            <div className='stock-skeleton__product-image'></div>
          </div>
          <div className='stock-skeleton__row-cell stock-skeleton__row-cell--created'>
            <div className='stock-skeleton__date'></div>
          </div>
          <div className='stock-skeleton__row-cell stock-skeleton__row-cell--name'>
            <div className='stock-skeleton__product-name'></div>
          </div>
          <div className='stock-skeleton__row-cell stock-skeleton__row-cell--brand'>
            <div className='stock-skeleton__brand-name'></div>
          </div>
          <div className='stock-skeleton__row-cell stock-skeleton__row-cell--cost'>
            <div className='stock-skeleton__price'></div>
          </div>
          <div className='stock-skeleton__row-cell stock-skeleton__row-cell--available'>
            <div className='stock-skeleton__quantity'></div>
          </div>
          <div className='stock-skeleton__row-cell stock-skeleton__row-cell--restock'>
            <div className='stock-skeleton__restock-icon'></div>
          </div>
          <div className='stock-skeleton__row-cell stock-skeleton__row-cell--move'>
            <div className='stock-skeleton__move-btn'></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WarehouseSkeleton;
